<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-error tw-text-center tw-ml-auto tw-w-full">
            <h1 class="tw-font-bold tw-text-center tw-pt-6 lg:tw-pt-10">Obrigado {{ $store.state.formName }}</h1>
            <p class="tw-text-center tw-pb-6 lg:tw-pb-10 tw-px-6 lg:tw-px-10">Verificámos que já tinha pedido um contacto anteriormente.<br><br>A nossa equipa irá entrar em contacto consigo o mais breve possível para o ajudar e esclarecer!</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormError',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';
.form-error {
    box-shadow: 2px 2px 12px 0 rgba(0,0,0,.1);

    @screen lg {
        box-shadow: none;
    }

    .form-title {
        @apply tw-relative tw-pt-10 tw-pb-3 tw-w-full;
        background-color: $main_color;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        font-size: 26px;

        @screen lg {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }

        &::before {
            @apply tw-absolute tw-bg-no-repeat tw-bg-center tw-rounded-full;
            background-size: 60%;
            background-color: $main_color;
            background-image: url('~@/assets/img/icons/car.svg');
            content: '';
            width: 85px;
            height: 85px;
            top: -42.5px;
        }
    }

    h1 {
        color: #fff !important;
        color: $main_color;
        font-size: 32px;
        font-family: $font_title;

        @screen lg {
            font-size: 48px;
        }
    }

    p {
        color: #fff !important;
        font-family: $font_title;
        text-transform: uppercase;
        font-size: 23px;
        margin-top: 14px;
        font-weight: 400;
        color: $dark;
    }
}

</style>
